export const VIDEO_TOUR_INSTANCE_ADDED = "VIDEO_TOUR_INSTANCE_ADDED";
export const VIDEO_TOUR_INSTANCE_REMOVED = "VIDEO_TOUR_INSTANCE_REMOVED";
export const SET_VIDEO_TOUR_CLOCK_TICKS = "SET_VIDEO_TOUR_CLOCK_TICKS";
